// extracted by mini-css-extract-plugin
export default {"dropZone":"dropzone_dropZone__g1zZZ","containerFile":"dropzone_containerFile__6uNFm","btnDelete":"dropzone_btnDelete__PWquj"};